// Base configuration
const baseUrl = "https://proxy.fastrak.uk";
const COMPANY_NAME = "dirtstore";
const STAR_IMAGE_URL = "https://store.brth.uk/fastrak/{rating}-stars.svg";

const reviewsOptions = {
    method: "GET",
    redirect: "follow"
};

let reviewsData = [];

// Get SKUs from ShopifyAnalytics
function getProductSkus() {
    if (window.ShopifyAnalytics?.meta?.product?.variants) {
        return window.ShopifyAnalytics.meta.product.variants
            .map(variant => variant.sku)
            .filter(sku => sku);
    }
    return null;
}

// Fetch reviews data
async function fetchData() {
    const mainContainer = document.getElementById(`fastrak_${COMPANY_NAME}-pc`);

    try {
        const reviewsResponse = await fetch(`${baseUrl}/dirtstore-reviews`, reviewsOptions);
        const reviewsResult = await reviewsResponse.json();
        
        if (reviewsResult.status === "OK" && reviewsResult.data.reviews && reviewsResult.data.reviews.length > 0) {
            reviewsData = reviewsResult.data.reviews;
            mainContainer.style.display = 'block';
            initializeComponents();
        }
    } catch (error) {
        console.error('Error fetching reviews:', error);
    }
}

// Initialize all components
function initializeComponents() {
    updateProductCarousel();
}


// Utility function to format date
function formatDate(dateString) {
    const date = new Date(dateString);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
}

function getStarImageUrl(rating) {
    return STAR_IMAGE_URL.replace('{rating}', Math.round(rating));
}

function updateProductCarousel() {
    console.log('Updating carousel...');
    const swiperContainer = document.getElementById(`fastrak_${COMPANY_NAME}-pc`);
    if (!swiperContainer) {
        console.error('Swiper container not found');
        return;
    }

    const reviewCards = document.getElementById(`fastrak_${COMPANY_NAME}-review-cards-carousel`);
    if (!reviewCards) {
        console.error('Review cards container not found');
        return;
    }
    
    console.log('Found containers, adding reviews...');
    reviewCards.innerHTML = '';
    
    let visibleReviews = reviewsData.slice(0, 20);
    
    visibleReviews.forEach(review => {
        const reviewCard = document.createElement("a");
        reviewCard.className = "swiper-slide";
        reviewCard.href = `https://uk.trustpilot.com/reviews/${review.review_id}`;
        reviewCard.target = '_blank';
        reviewCard.rel = 'noopener noreferrer';
        
        reviewCard.innerHTML = `
            <div class="fastrak_${COMPANY_NAME}-stars-container">
                <img class="fastrak_${COMPANY_NAME}-stars" src="${getStarImageUrl(review.review_rating)}" alt="${review.review_rating} stars">
            </div>
            <div class="fastrak_${COMPANY_NAME}-review-text">${review.review_text}</div>
            <div class="fastrak_${COMPANY_NAME}-reviewer-info">
                <span class="fastrak_${COMPANY_NAME}-reviewer-name">${review.consumer_name}</span>
                <span class="fastrak_${COMPANY_NAME}-review-date">${formatDate(review.review_time)}</span>
            </div>
        `;
        reviewCards.appendChild(reviewCard);
    });

    console.log('Reviews added, initializing Swiper...');
    if (typeof Swiper !== 'undefined') {
        new Swiper('.swiper', {
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            slidesPerView: 4,
            spaceBetween: 24,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                hideOnClick: false,
            },
            on: {
                slideChange: function(swiper) {
                    const activeIndex = swiper.realIndex;
                    const review = visibleReviews[activeIndex];
                    if (review) {
                        reviewCards.href = `https://uk.trustpilot.com/reviews/${review.review_id}`;
                        reviewCards.target = '_blank';
                        reviewCards.rel = 'noopener noreferrer';
                    }
                },
                init: function(swiper) {
                    const firstReview = visibleReviews[0];
                    if (firstReview) {
                        reviewCards.href = `https://uk.trustpilot.com/reviews/${firstReview.review_id}`;
                        reviewCards.target = '_blank';
                        reviewCards.rel = 'noopener noreferrer';
                    }
                }
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
        });
        console.log('Swiper initialized');
    } else {
        console.error('Swiper library not found');
    }
}

// Initialize data fetch on page load - DISABLED FOR NOW
// document.addEventListener('DOMContentLoaded', fetchData);